// extracted by mini-css-extract-plugin
export var askAiIcon = "_n8-j";
export var category = "_n8-9";
export var categoryHeader = "_n8-e";
export var container = "_n8-0";
export var group = "_n8-a";
export var groupItems = "_n8-f";
export var groupSeparator = "_n8-k";
export var loading = "_n8-1";
export var noResults = "_n8-3";
export var placeholder = "_n8-2";
export var resultContent = "_n8-5";
export var resultIcon = "_n8-c";
export var resultItem = "_n8-g";
export var resultMeta = "_n8-8";
export var resultSubtitle = "_n8-7";
export var resultSuffix = "_n8-i";
export var resultTitle = "_n8-6";
export var resultsList = "_n8-4";
export var searchGroup = "_n8-d";
export var selected = "_n8-h";
export var subgroup = "_n8-b";